/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DesktopFooter } from './DesktopFooter';
import { MobileFooter } from './MobileFooter';
import { TabletFooter } from './TabletFooter';
import withCssProps from '../../hocs/withCssProps';
var AgroFooterV2 = withCssProps(function (_ref) {
  var footerData = _ref.footerData,
    tagManager = _ref.tagManager,
    isDarkMode = _ref.isDarkMode,
    toggleMode = _ref.toggleMode;
  return /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(DesktopFooterContainer, null, /*#__PURE__*/React.createElement(DesktopFooter, {
    footerData: footerData,
    tagManager: tagManager,
    isDarkMode: isDarkMode,
    toggleMode: toggleMode
  })), /*#__PURE__*/React.createElement(MobileFooterContainer, null, /*#__PURE__*/React.createElement(MobileFooter, {
    footerData: footerData,
    tagManager: tagManager,
    isDarkMode: isDarkMode,
    toggleMode: toggleMode
  })), /*#__PURE__*/React.createElement(TabletFooterContainer, null, /*#__PURE__*/React.createElement(TabletFooter, {
    footerData: footerData,
    tagManager: tagManager,
    isDarkMode: isDarkMode,
    toggleMode: toggleMode
  })));
});
AgroFooterV2.propTypes = {
  footerData: PropTypes.object.isRequired,
  tagManager: PropTypes.func,
  isDarkMode: PropTypes.bool,
  toggleMode: PropTypes.func
};
AgroFooterV2.displayName = 'AgroFooter';
export { AgroFooterV2 };
var Footer = styled.div.withConfig({
  displayName: "AgroFooterV2__Footer",
  componentId: "sc-1kv3kel-0"
})(["background-color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray900;
});
var MobileFooterContainer = styled.div.withConfig({
  displayName: "AgroFooterV2__MobileFooterContainer",
  componentId: "sc-1kv3kel-1"
})(["@media (min-width:", "){display:none;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint.md;
});
var TabletFooterContainer = styled.div.withConfig({
  displayName: "AgroFooterV2__TabletFooterContainer",
  componentId: "sc-1kv3kel-2"
})(["display:none;@media (min-width:", ") and (max-width:calc( ", " - 0.02px )){display:block;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoint.md;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoint.xl;
});
var DesktopFooterContainer = styled.div.withConfig({
  displayName: "AgroFooterV2__DesktopFooterContainer",
  componentId: "sc-1kv3kel-3"
})(["display:none;@media (min-width:", "){display:block;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoint.xl;
});